// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2BEvk","actionsCol":"EnrolledClinics_actionsCol__Dxj-H"};